app.controller("StudentNewQuestionnairesController", [
    "$scope", "$stateParams", "Students", "FreshModal", "$state", "QuestionnairesService", "AuthService", "usSpinnerService",
    function ($scope, $stateParams, Students, FreshModal, $state, QuestionnairesService, AuthService, usSpinnerService) {

        $scope.loaded = false;

        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                if (p.type === 'student' && p.state === 'active') {
                    return p;
                }
            })[0] || user.profiles.filter(function (p) {
                return p.type === 'student';
            })[0];

            loadPage();
        });

        $scope.open = function (item, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                backdrop: 'static',
                keyboard: false,
                controller: "QuestionnaireWindowController",
                templateUrl: _pb + 'student-new/questionnaire-window.html',
                resolve: {
                    params: function () {
                        return {questionnaire: item};
                    }
                }
            }).then(function () {
                loadPage();
            });
        };

        function loadPage(cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            QuestionnairesService.getListByProfile($scope.profile._id).then(function (data) {
                $scope.questionnaires = data;
                $scope.loaded = true;
                usSpinnerService.stop("root");
                cb();
            }).catch(function () {
                usSpinnerService.stop("root");
            });
        }
    }
]);
